import { render, staticRenderFns } from "./trafficPackage.vue?vue&type=template&id=1974c362&scoped=true&"
import script from "./trafficPackage.vue?vue&type=script&lang=js&"
export * from "./trafficPackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1974c362",
  null
  
)

export default component.exports